import { Layout } from "@/components/layout/Layout";
import { FunnelIndexCard } from "@/components/funnels/FunnelIndexCard";
import { funnels } from "@/data/funnels";

export default function FunnelIndex() {
  return (
    <Layout>
      {/* Unlisted: reachable by direct URL only, never indexed. */}
      <meta name="robots" content="noindex, nofollow" />
      <section className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mb-12">
          <h1 className="text-4xl md:text-5xl font-serif font-medium mb-6">
            AgelessRx Funnel Concepts
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Interactive prototypes exploring outcome-oriented patient journeys, personalized
            intake experiences, and continuity into the AgelessRx patient portal.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {funnels.map((funnel) => (
            <FunnelIndexCard key={funnel.id} funnel={funnel} />
          ))}
        </div>
      </section>
    </Layout>
  );
}
